import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Grid from '@material-ui/core/Grid'

import { Button } from '../atoms'

interface ActiveStatusFilterControlsProps {
  active: boolean
  setActiveFilter: (active: boolean) => void
}

const ActiveStatusFilterControls = ({
  active,
  setActiveFilter,
}: ActiveStatusFilterControlsProps) => (
  <Grid
    container
    justify={'flex-end'}
    spacing={8}
  >
    <Grid item>
      <Button
        secondary
        variant={active ? 'raised' : undefined}
        onClick={() => setActiveFilter(true)}
      >
        <FormattedMessage id={'dictionary.active'} />
      </Button>
    </Grid>
    <Grid item>
      <Button
        color={'primary'}
        variant={!active ? 'raised' : undefined}
        onClick={() => setActiveFilter(false)}
      >
        <FormattedMessage id={'dictionary.inactive'} />
      </Button>
    </Grid>
  </Grid>
)

export default ActiveStatusFilterControls



// WEBPACK FOOTER //
// ./src/components/molecules/ActiveStatusFilterControls.tsx